import { useState } from "react";
import StudioFolderEntryCard from "./StudioFolderEntryCard.jsx";
import "../../../styles/studio/folder/studioFolderGridView.css";

/**
 * Grid view for folder entries with drag-and-drop reordering
 */
const StudioFolderGridView = ({
  entries = [],
  setEntries,
  currentFolderPath = [], // ✅ receive path instead of folderId
  globalLoading = false,
  setGlobalLoading,
  isReorderMode = false,
  fetchData,
  setError,
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  /* ---------------- DRAG START ---------------- */
  const handleDragStart = (e, index) => {
    if (!isReorderMode || globalLoading) return;
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  /* ---------------- DRAG OVER ---------------- */
  const handleDragOver = (e) => {
    if (!isReorderMode || globalLoading) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  /* ---------------- DROP ---------------- */
  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (!isReorderMode || globalLoading) return;
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const updated = [...entries];
    const [draggedItem] = updated.splice(draggedIndex, 1);

    const insertIndex = draggedIndex < dropIndex ? dropIndex - 1 : dropIndex;
    updated.splice(insertIndex, 0, draggedItem);

    setEntries(updated);
    setDraggedIndex(null);
  };

  const handleDragEnd = () => setDraggedIndex(null);

  return (
    <div className="studio-folder-grid-view">
      {entries.map((entry, idx) => (
        <div
          key={entry.folderEntryId || entry.itemId}
          draggable={isReorderMode && !globalLoading}
          onDragStart={(e) => handleDragStart(e, idx)}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, idx)}
          onDragEnd={handleDragEnd}
        >
          <StudioFolderEntryCard
            entry={entry}
            currentFolderPath={currentFolderPath}
            globalLoading={globalLoading}
            setGlobalLoading={setGlobalLoading}
            fetchData={fetchData}
            setError={setError}
          />
        </div>
      ))}
    </div>
  );
};

export default StudioFolderGridView;
